import { themeColors } from './colors';
import { themeFonts } from './fonts';
import { themeRadius } from './radius';
import { themeSpacing } from './spacing';
export const theme = {
  dime: {
    colors: themeColors,
    spacing: themeSpacing,
    radius: themeRadius,
    fonts: themeFonts
  }
};
